// extracted by mini-css-extract-plugin
export var active = "_jo-2";
export var recordingDot = "_jo-1";
export var recordingIndicator = "_jo-0";